<template>
  <div v-if="$ability.can('read', this.$route.meta.resource)">
    <sidebar
      :store-module-name="STORE_MODULE_NAME"
      :store-module-name-product="STORE_MODULE_NAME_PRODUCT"
      :store-module-name-coupon="STORE_MODULE_NAME_COUPON"
      :store-module-name-coupon-category="STORE_MODULE_NAME_COUPON_CATEGORY"
      :store-module-name-product-category="STORE_MODULE_NAME_PRODUCT_CATEGORY"
      :store-module-name-questionnaire="STORE_MODULE_NAME_QUESTIONNAIRE"
      :is-sidebar-active.sync="isSidebarActive"
      :show.sync="show"
      :data="sidebarData"
    />
    <modal-select-product
      :is-modal-active.sync="isModalSelectProductActive"
      :promote-id="$route.params.id"
      :store-module-name="STORE_MODULE_NAME"
      @success="get"
    />
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col>
              <label>{{ $t("Show") }} {{ queriedItems }} {{ $t("entries") }}</label>
            </b-col>

            <b-col
              cols="12"
              md="6"
              class="b-col-custom"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('Search') + '...'"
                  @input="typing($event)"
                />
                <b-button
                  v-if="typeLink === 'product'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="d-flex mr-1"
                  @click="isModalSelectProductActive = true"
                >
                  <feather-icon icon="CheckSquareIcon" class="mr-50" />
                  <span class="align-middle">{{ $t('เลือกสินค้าหลายรายการ') }}</span>
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="d-flex"
                  @click="sidebarAddNew()"
                >
                  <feather-icon icon="PlusIcon" />
                  <!-- <span class="align-middle">Add Users</span> -->
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="m-2 mb-0">
          <b-row>
            <b-col cols="1">
              <div class="d-flex align-items-center justify-content-center">
                {{ $t('Order') }}
              </div>
            </b-col>
            <b-col cols="1">
              <div class="d-flex align-items-center justify-content-center">
                {{ $t('Image') }}
              </div>
            </b-col>
            <b-col cols="4">
              <div class="d-flex align-items-center justify-content-start">
                {{ $t('Name') }}
              </div>
            </b-col>
            <b-col cols="4">
              <div class="d-flex align-items-center justify-content-start">
                {{ $t('Item') }}
              </div>
            </b-col>
            <b-col cols="2">
              <div class="d-flex align-items-center justify-content-center">
                {{ $t('Action') }}
              </div>
            </b-col>
          </b-row>
          <hr>
          <div
            v-if="myArray.length === 0"
            class="mt-1"
          >
            <b-row>
              <b-col cols="12">
                <div class="d-flex align-items-center justify-content-center">
                  {{ $t('No matching records found') }}
                </div>
              </b-col>
            </b-row>
          </div>
          <draggable
            v-model="myArray"
            @change="updateOrder"
          >
            <div
              v-for="(data,index) in myArray"
              :key="index"
              class="mt-1"
            >
              <b-row>
                <b-col cols="1">
                  <div class="d-flex align-items-center justify-content-center">

                    {{ index + 1 }}
                  </div>
                </b-col>
                <b-col cols="1">
                  <div class="d-flex align-items-center justify-content-center">
                    <template v-if="typeLink === 'coupon'">

                      <b-img
                        v-if="data.couponId.image"
                        :src="data.couponId.image"
                        fluid
                        thumbnail
                        style="height: 60px;"
                        :alt="'Users_' + data._id"
                      />
                      <b-img
                        v-else
                        :src="require('@/assets/images/blank/no_image.png')"
                        fluid
                        thumbnail
                        style="height: 60px;"
                        :alt="'Users_' + data._id"
                      />

                    </template>
                    <template v-if="typeLink === 'link'">

                      <b-img
                        v-if="data.image"
                        :src="data.image"
                        fluid
                        thumbnail
                        style="height: 60px;"
                        :alt="'Users_' + data._id"
                      />
                      <b-img
                        v-else
                        :src="require('@/assets/images/blank/no_image.png')"
                        fluid
                        thumbnail
                        style="height: 60px;"
                        :alt="'Users_' + data._id"
                      />

                    </template>
                    <template v-if="typeLink === 'product'">

                      <b-img
                        v-if="data.productId.images.length>0"
                        :src="data.productId.images[0]"
                        fluid
                        thumbnail

                        :alt="'Users_' + data._id"
                        style="height: 60px;"
                      />
                      <b-img
                        v-else
                        :src="require('@/assets/images/blank/no_image.png')"
                        fluid
                        thumbnail
                        style="height: 60px;"
                        :alt="'Users_' + data._id"
                      />

                    </template>
                  </div>
                </b-col>
                <b-col cols="4">

                  <p
                    v-for="(item, index) in data.name"
                    :key="index"
                    class="align-self-center"
                  >{{ item.lang.toUpperCase() }}: {{ item.value }}</p>

                </b-col>
                <b-col cols="4">
                  <template v-if="typeLink === 'coupon'">
                    <p
                      v-for="(item, index) in data.couponId.name"
                      :key="index"
                      class="align-middle ml-50"
                    >{{ item.lang.toUpperCase() }}: {{ item.value }}</p>
                  </template>
                  <template v-if="typeLink === 'link'">
                    <p
                      class="align-middle ml-50"
                    > {{ data.link }}</p>
                  </template>
                  <template v-if="typeLink === 'product'">
                    <template v-if=" data.productId.optionNameTranslate === 'multiple'">
                      <p
                        v-for="(item, index) in data.productId.nameTranslate"
                        :key="index"
                        class="align-middle ml-50"
                      >{{ item.lang.toUpperCase() }}: {{ item.value }}</p>
                    </template>
                    <template v-if=" data.productId.optionNameTranslate === 'single'">
                      <p
                        class="align-middle ml-50"
                      > {{ data.productId.name }}</p>
                    </template>
                  </template></b-col>
                <b-col cols="2">
                  <div class="d-flex align-items-center justify-content-center">

                    <b-dropdown
                      variant="link"
                      no-caret
                      :right="$store.state.appConfig.isRTL"
                    >
                      <template #button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="align-middle text-body"
                        />
                      </template>
                      <b-dropdown-item
                        v-if="typeLink === 'html'"
                        @click="htmlEdit(data._id)"
                      >
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">{{ $t("HTML") }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="sidebarEdit(data)">
                        <feather-icon icon="EditIcon" />
                        <span class="align-middle ml-50">{{ $t("Edit") }}</span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="deleteData(data._id)">
                        <feather-icon icon="TrashIcon" />
                        <span class="align-middle ml-50">{{ $t("Delete") }}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </b-col>
              </b-row>
            </div>
          </draggable>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BAvatar,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BDropdown,
  BOverlay,
  BCardText,
  BDropdownItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import perPageOptions from '@/perPageOptions'
// import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/store/services/eCommerce/promoteList'
import storeModuleProduct from '@/store/services/eCommerce/product'
import storeModuleCoupon from '@/store/services/eCommerce/coupon'
import storeModuleCouponCategory from '@/store/services/eCommerce/couponCategory'
import storeModuleProductCategory from '@/store/services/eCommerce/productCategory'
import storeModuleQuestionnaire from '@/store/services/eCommerce/questionnaire'
import debounce from 'debounce'
import draggable from 'vuedraggable'
import Sidebar from './DataSidebar.vue'
import ModalSelectProduct from './ModalSelectProduct.vue'

const STORE_MODULE_NAME = 'promoteList'
const STORE_MODULE_NAME_PRODUCT = 'product'
const STORE_MODULE_NAME_COUPON = 'coupon'
const STORE_MODULE_NAME_COUPON_CATEGORY = 'couponCategory'
const STORE_MODULE_NAME_PRODUCT_CATEGORY = 'productCategory'
const STORE_MODULE_NAME_QUESTIONNAIRE = 'questionnaire'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    // eslint-disable-next-line vue/no-unused-components
    BAvatar,
    BFormInput,
    BButton,
    Sidebar,
    ModalSelectProduct,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BCardText,

    // BFormFile,
    // BBadge,
    // BLink,
    // BMedia,
    // BAvatar,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      avatarText,
      currentPage: 1,
      searchQuery: '',
      perPage: localStorage.getItem('itemsPerPage')
        ? localStorage.getItem('itemsPerPage')
        : 30,
      isSidebarActive: false,
      isModalSelectProductActive: false,
      sidebarData: {},
      show: false,
      myArray: [],
      perPageOptions,
    }
  },
  computed: {
    tableColumns() {
      return [
        { key: 'image', label: this.$t('Image'), sortable: false },
        { key: 'name', label: this.$t('Name'), sortable: false },
        { key: 'item', label: this.$t('Item'), sortable: false },
        // { key: 'lastName', label: this.$t('LastName'), sortable: false },
        { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    respData() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.data
        : []
    },
    queriedItems() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.max
        : 0
    },
    typeLink() {
      return store.state[STORE_MODULE_NAME].respData != null
        ? store.state[STORE_MODULE_NAME].respData.typeLink
        : ''
    },
  },
  created() {
    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)
    if (!store.hasModule(STORE_MODULE_NAME_PRODUCT)) store.registerModule(STORE_MODULE_NAME_PRODUCT, storeModuleProduct)
    if (!store.hasModule(STORE_MODULE_NAME_COUPON)) store.registerModule(STORE_MODULE_NAME_COUPON, storeModuleCoupon)
    if (!store.hasModule(STORE_MODULE_NAME_COUPON_CATEGORY)) {
      store.registerModule(
        STORE_MODULE_NAME_COUPON_CATEGORY,
        storeModuleCouponCategory,
      )
    }
    if (!store.hasModule(STORE_MODULE_NAME_PRODUCT_CATEGORY)) {
      store.registerModule(
        STORE_MODULE_NAME_PRODUCT_CATEGORY,
        storeModuleProductCategory,
      )
    }
    if (!store.hasModule(STORE_MODULE_NAME_QUESTIONNAIRE)) store.registerModule(STORE_MODULE_NAME_QUESTIONNAIRE, storeModuleQuestionnaire)

    this.get()
    this.typing = debounce(this.typing, 500)
  },
  destroyed() {
    if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    if (store.hasModule(STORE_MODULE_NAME_PRODUCT)) store.unregisterModule(STORE_MODULE_NAME_PRODUCT)
    if (store.hasModule(STORE_MODULE_NAME_COUPON)) store.unregisterModule(STORE_MODULE_NAME_COUPON)
    if (store.hasModule(STORE_MODULE_NAME_COUPON_CATEGORY)) store.unregisterModule(STORE_MODULE_NAME_COUPON_CATEGORY)
    if (store.hasModule(STORE_MODULE_NAME_PRODUCT_CATEGORY)) store.unregisterModule(STORE_MODULE_NAME_PRODUCT_CATEGORY)
    if (store.hasModule(STORE_MODULE_NAME_QUESTIONNAIRE)) store.unregisterModule(STORE_MODULE_NAME_QUESTIONNAIRE)
  },
  setup() {
    return {
      STORE_MODULE_NAME,
      STORE_MODULE_NAME_PRODUCT,
      STORE_MODULE_NAME_COUPON,
      STORE_MODULE_NAME_COUPON_CATEGORY,
      STORE_MODULE_NAME_PRODUCT_CATEGORY,
      STORE_MODULE_NAME_QUESTIONNAIRE,
    }
  },
  methods: {
    htmlEdit(id) {
      this.$router.push({
        name: 'e-commerce-product-view-html',
        params: { id },
      })
    },
    updateOrder() {
      store
        .dispatch(`${STORE_MODULE_NAME}/updateOrder`, { list: this.myArray })
        .then(result => {
          // this.showToast('success', 'bottom-right')
          this.get()
        })
        .catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })

          // this.showToast('danger', 'bottom-right')
        })
    },
    get() {
      const obj = {
        promoteId: this.$route.params.id,
        currentPage: 0,
        pageSize: this.perPage,
        searchQuery: this.searchQuery,
      }

      this.show = true
      store
        .dispatch(`${STORE_MODULE_NAME}/get`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.show = false
          this.myArray = result.data.data
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        })
        .catch(error => {
          this.show = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    typing(value) {
      this.searchQuery = value
      this.get()
    },
    sidebarAddNew() {
      this.sidebarData = {}
      this.isSidebarActive = true
    },
    sidebarEdit(item) {
      this.sidebarData = item
      this.isSidebarActive = true
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.show = true
            store
              .dispatch(`${STORE_MODULE_NAME}/delete`, { id })
              .then(result => {
                this.show = false
              })
              .catch(error => {
                this.show = false
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
              })
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    pageSize(size) {
      localStorage.setItem('itemsPerPage', size)
      this.perPage = size
      this.get()
    },
    nextPage(page) {
      this.currentPage = page
      this.get()
    },
    showToast(variant, position, text, icon, title) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title,
            icon,
            text,
            // icon: 'InfoIcon',
            // text: 'I do not think that word means what you think it means.',
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.v-select-custom {
  display: inline-block;
  width: 50;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.b-col-custom {
  margin-top: 0.5rem;
}
</style>
